import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "p-5"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "text-center"
};
const _hoisted_4 = {
  class: "text-center"
};
const _hoisted_5 = {
  class: "text-center"
};
const _hoisted_6 = {
  class: "text-center"
};
import { reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
import { useImportStore } from './useImportStore';
export default {
  __name: 'Import',
  props: {
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      imports,
      loading,
      sessionToken,
      templates
    } = storeToRefs(useImportStore());
    const {
      listImports,
      initiateSession,
      deleteImport,
      completeImport,
      resumeSession,
      syncImport,
      listTemplates
    } = useImportStore();
    listImports();
    listTemplates();
    const props = __props;
    const state = reactive({
      undoDialog: false,
      selectedItemId: null,
      result: null
    });
    const confirmUndo = itemId => {
      state.selectedItemId = itemId;
      state.undoDialog = true;
    };
    const confirmSync = () => {
      state.syncDialog = true;
    };
    const syncFirm = async () => {
      state.syncDialog = false;
      state.result = await syncImport();
    };
    const undoItem = async () => {
      state.undoDialog = false;
      state.result = await deleteImport(state.selectedItemId);
    };
    const confirmComplete = itemId => {
      state.selectedItemId = itemId;
      state.completeDialog = true;
    };
    const completeItem = async () => {
      state.completeDialog = false;
      state.result = await completeImport(state.selectedItemId);
    };
    const displayCount = (item, key) => {
      return item.counts ? item.counts[key] : '-';
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_table = _resolveComponent("v-table");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), template => {
          return _openBlock(), _createBlock(LlSecondaryButton, {
            key: template.id,
            class: "m-2",
            onClick: $event => _unref(initiateSession)(template.id)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(template.description), 1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128)), _createVNode(LlSecondaryButton, {
          class: "m-2",
          onClick: _cache[0] || (_cache[0] = $event => confirmSync())
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" QuickBooks Sync ", -1)]))]),
          _: 1
        }), _unref(sessionToken) ? (_openBlock(), _createBlock(LlSecondaryButton, {
          key: 0,
          class: "m-2",
          color: "warning",
          onClick: _cache[1] || (_cache[1] = $event => _unref(resumeSession)())
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("Resume", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("Imports", -1)]))]),
            _: 1
          }), _unref(loading) ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading...")) : (_openBlock(), _createBlock(_component_v_table, {
            key: 1,
            density: "compact"
          }, {
            default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "Id"), _createElementVNode("th", null, "Type"), _createElementVNode("th", null, "Status"), _createElementVNode("th", null, "OneSchema Rows"), _createElementVNode("th", {
              class: "text-center"
            }, [_createTextVNode("LeanLaw "), _createElementVNode("br"), _createTextVNode(" (Primary)")]), _createElementVNode("th", {
              class: "text-center"
            }, "QuickBooks"), _createElementVNode("th", {
              class: "text-center"
            }, [_createTextVNode("LeanLaw "), _createElementVNode("br"), _createTextVNode(" (Secondary)")]), _createElementVNode("th", {
              class: "text-center"
            }, "QuickBooks"), _createElementVNode("th", {
              class: "text-center"
            }, " ")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imports), item => {
              return _openBlock(), _createElementBlock("tr", {
                key: item.id
              }, [_createElementVNode("td", null, [_createElementVNode("a", {
                href: item.link,
                target: "_blank",
                rel: "noopener noreferrer"
              }, _toDisplayString(item.id), 9, _hoisted_2)]), _createElementVNode("td", null, _toDisplayString(item.template), 1), _createElementVNode("td", null, _toDisplayString(item.status), 1), _createElementVNode("td", null, _toDisplayString(item.rows), 1), _createElementVNode("td", _hoisted_3, _toDisplayString(displayCount(item, 'primary')), 1), _createElementVNode("td", _hoisted_4, _toDisplayString(displayCount(item, 'primaryQBO')), 1), _createElementVNode("td", _hoisted_5, _toDisplayString(displayCount(item, 'secondary')), 1), _createElementVNode("td", _hoisted_6, _toDisplayString(displayCount(item, 'secondaryQBO')), 1), _createElementVNode("td", null, [item.showUndo ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                onClick: $event => confirmUndo(item.id)
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("mdi-delete", -1)]))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true), item.showComplete ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                onClick: $event => confirmComplete(item.id)
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("mdi-import", -1)]))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true)])]);
            }), 128))])]),
            _: 1
          }))]),
          _: 1
        }), state.result ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("Results", -1)]))]),
            _: 1
          }), _createTextVNode(" " + _toDisplayString(state.result.success ? 'Success' : 'Errors') + " ", 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.result.errors, error => {
            return _openBlock(), _createElementBlock("li", {
              key: error.id
            }, [_createTextVNode(_toDisplayString(error.message), 1), _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)), _createTextVNode(" " + _toDisplayString(error.exception), 1)]);
          }), 128))])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_v_dialog, {
          modelValue: state.undoDialog,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.undoDialog = $event),
          "max-width": "290"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "headline"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("Confirm Undo", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Are you sure you want to delete all the items related to this import? It cannot be undone. If the client has made changes to the data, it cannot be recovered.", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                onClick: _cache[2] || (_cache[2] = $event => state.undoDialog = false)
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" Cancel ", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                onClick: undoItem
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("Undo", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
          modelValue: state.completeDialog,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => state.completeDialog = $event),
          "max-width": "290"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "headline"
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("Confirm Complete Import", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" Are you sure you want to insert all the items for this import into the firm? ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                onClick: _cache[4] || (_cache[4] = $event => state.completeDialog = false)
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode(" Cancel ", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                onClick: completeItem
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("Go!", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
          modelValue: state.syncDialog,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.syncDialog = $event),
          "max-width": "290"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "headline"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("Sync to QuickBooks", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Do you want to sync all the clients and matters to QuickBooks? Make sure you have client or matter accounting selected in settings. ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                onClick: _cache[6] || (_cache[6] = $event => state.syncDialog = false)
              }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" Cancel ", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                onClick: syncFirm
              }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("Sync", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
};